import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const NutritionService = {
    GetNutritionQuestions,SaveNutritionData,GetNutritionData
 // GetAllAbstractors, AddUpdateAbstractor,DeleteAbstractor
};

function GetNutritionQuestions() {
  return WebServiceWrapper.Get(`/nutrition/GetNutritionQuestions`);
}
function SaveNutritionData(payload) {
  return WebServiceWrapper.Post("/nutrition/SaveNutritionData",payload); 
}
function GetNutritionData(patientId) {
  return WebServiceWrapper.Get(`/nutrition/GetNutritionData?patientId=${patientId}&isAdmin=${IsAdmin()}`);
}


